import { Card, Container, Tab, Tabs, Typography } from '@mui/material';
import logo from './tests/testAdmin/testList/navigation/logo.png';
import React from 'react';
import { getCurrentVersion } from '../app/version-info';

export function ImpressumCardContent() {
  const [language, setLanguage] = React.useState<'de' | 'en'>('en');
  return (
    <Container
      sx={{
        pt: 8,
        gap: 4,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <img src={logo} alt="logo" />
      <Tabs value={language} onChange={(_, val) => setLanguage(val)}>
        <Tab value="en" label="English" />
        <Tab value="de" label="Deutsch" />
      </Tabs>
      <Card sx={{ width: '100%', mb: '2em', padding: '1em' }}>
        {language === 'de' && (
          <>
            <Typography sx={{ mt: '1em' }}>
              <b>
                MIND.set ist ein Projekt des Deutsches Zentrums für
                Integrations- und Migrationsforschung DeZIM e.V.
              </b>
              <br /> <br />
            </Typography>
            <Typography variant="h4">Zitation</Typography>
            <blockquote>
              Veit, S., Essien, I., Hechler, S., & Zey, E. (2025). MIND.set (
              <i>{`Version ${getCurrentVersion()}`}</i>) [Software].
              DeZIM-Institut. https://mindset.dezim-institut.de
            </blockquote>
            <Typography variant="h4">Kontakt</Typography>
            <Typography sx={{ mt: '1em' }}>
              MIND.set Team: mindset(at)dezim-institut.de
            </Typography>

            <Typography sx={{ mt: '1em' }}>
              Anfragen rund um Registrierung und Accounts:
              admin.mindset(at)dezim-institut.de
            </Typography>
            <Typography sx={{ mt: '1em' }} variant="h4">
              Impressum
            </Typography>
            <Typography sx={{ mt: '1em' }}>Angaben gemäß § 5 TMG</Typography>

            <Typography sx={{ mt: '1em' }}>
              Deutsches Zentrum für Integrations- und Migrationsforschung DeZIM
              e.V.{' '}
            </Typography>
            <Typography> Mauerstrasse 76 </Typography>
            <Typography> 10117 Berlin </Typography>

            <Typography>Tel: +49 (0) 30 - 804 928 93</Typography>

            <Typography>Mail: info@dezim-institut.de</Typography>

            <Typography sx={{ mt: '1em' }}>
              <b>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</b>
            </Typography>
            <Typography>Naika Foroutan / Frank Kalter </Typography>
            <Typography>Mauerstrasse 76 </Typography>
            <Typography> 10117 Berlin</Typography>

            <Typography variant="h4" sx={{ mt: '1em' }}>
              Technische Umsetzung
            </Typography>
            <Typography sx={{ mt: '1em' }}>
              Die technische Umsetzung erfolgt durch{' '}
              <a href="https://devconsult.berlin" target="_blank">
                DevConsult Berlin
              </a>
              .
            </Typography>
          </>
        )}

        {language === 'en' && (
          <>
            <Typography sx={{ mt: '1em' }}>
              <b>
                MIND.set is a project of the German Center for Integration and
                Migration Research DeZIM e.V.
              </b>
              <br /> <br />
            </Typography>
            <Typography variant="h4">Citation</Typography>
            <blockquote>
              Veit, S., Essien, I., Hechler, S., & Zey, E. (2025). MIND.set (
              <i>{`Version ${getCurrentVersion()}`}</i>) [Software].
              DeZIM-Institut. https://mindset.dezim-institut.de
            </blockquote>
            <Typography variant="h4">Contact</Typography>
            <Typography sx={{ mt: '1em' }}>
              MIND.set Team: mindset(at)dezim-institut.de
            </Typography>

            <Typography sx={{ mt: '1em' }}>
              Inquiries about registration and accounts:
              admin.mindset(at)dezim-institut.de
            </Typography>
            <Typography sx={{ mt: '1em' }} variant="h4">
              Legal Notes
            </Typography>
            <Typography sx={{ mt: '1em' }}>
              Information according to § 5 TMG
            </Typography>

            <Typography sx={{ mt: '1em' }}>
              German Center for Integration and Migration Research DeZIM e.V.
            </Typography>
            <Typography> Mauerstrasse 76 </Typography>
            <Typography> 10117 Berlin </Typography>

            <Typography sx={{ mt: '1em' }}>
              Tel: +49 (0) 30 - 804 928 93
            </Typography>

            <Typography sx={{ mt: '1em' }}>
              Mail: info@dezim-institut.de
            </Typography>

            <Typography sx={{ mt: '1em' }}>
              <b>Responsible for the content according to § 55 Abs. 2 RStV:</b>
            </Typography>
            <Typography>Naika Foroutan / Frank Kalter </Typography>
            <Typography>Mauerstrasse 76 </Typography>
            <Typography> 10117 Berlin</Typography>

            <Typography variant="h4" sx={{ mt: '1em' }}>
              Technical Implementation
            </Typography>
            <Typography sx={{ mt: '1em' }}>
              The technical implementation is carried out by{' '}
              <a href="https://devconsult.berlin" target="_blank">
                DevConsult Berlin
              </a>
              .
            </Typography>
          </>
        )}
      </Card>
    </Container>
  );
}

export function ImpressumScreen() {
  return (
    <Container
      sx={{
        pt: 8,
        gap: 4,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <img src={logo} alt="logo" />
      <ImpressumCardContent />
    </Container>
  );
}
